import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./M_DataStateRenderer.styles";
import { message } from "../../../../../Utils/config/messages";

const M_DataStateRenderer = ({
  loading,
  error,
  isInline = false,
  skeleton = null,
  data = null,
  emptyMessage = "",
  isEmpty = false,
  children,
}) => {
  const classes = useStyles();

  if (loading) return skeleton;

  if (error) {
    const errorCode =
      typeof error === "object"
        ? error.status || error.response?.status || "500"
        : error;
    const errorMsg =
      typeof error === "object"
        ? error.message
        : typeof error === "string" && isNaN(Number(error))
        ? error
        : null;
    const displayDetail = errorMsg || errorCode;

    if (isInline) {
      return (
        <Typography
          variant="caption"
          className={classes.messageText}
          style={{
            color: "var(--color-text-secondary)",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <span
            className={classes.errorText}
            style={{ fontSize: "10px", margin: 0 }}
          >
            Error:
          </span>
          Data service unavailable ({String(displayDetail)})
        </Typography>
      );
    }

    return (
      <Box className={classes.noDataState}>
        <Typography variant="body2" className={classes.messageText}>
          <span className={classes.errorText}>Something went wrong.</span>
          We were unable to load this data.
          <div
            style={{
              fontSize: "10px",
              marginTop: "4px",
              opacity: 0.8,
              fontWeight: 400,
            }}
          >
            Reference: {String(displayDetail)}
          </div>
          <div style={{ marginTop: "8px" }}>{message.SUPPORT_TEAM}</div>
        </Typography>
      </Box>
    );
  }

  if (isEmpty || (data && Array.isArray(data) && data.length === 0)) {
    return (
      <Box className={classes.noDataState || ""} py={2} textAlign="center">
        <Typography
          variant="body2"
          style={{
            color: "var(--color-text-secondary)",
            fontWeight: 500,
            letterSpacing: "0.025em",
          }}
        >
          {emptyMessage || message.NO_CONTENT_AVAILABLE}
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

M_DataStateRenderer.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
    PropTypes.number,
  ]),
  isInline: PropTypes.bool,
  skeleton: PropTypes.node,
  data: PropTypes.any,
  emptyMessage: PropTypes.string,
  isEmpty: PropTypes.bool,
  children: PropTypes.node,
};

export default M_DataStateRenderer;
